export default __webpack_public_path__ + "media/images/home/slide_howto_lg-bac82d18da0d778bccb9fd6d90e3e8fb.jpg";